import { getData, postData } from '@/utils/http'
import config from '@/config';
import moment from 'moment';
export default {
	namespaced: true,
	state: {
		dataLoading: true,

		selectProjectId: '',
		selectOrder:'',
		searchDate:moment().format("yyyy-MM")

	},
	mutations: {
		CHANGE_TABLE_LOADING(state, dataLoading) {
			state.dataLoading = dataLoading
		},
		CHANGE_SEARCH_COLL(state, changeData) {
			if (changeData['changeKey'] == 'orgId' && typeof changeData['data'] != 'object') {
				state[changeData['changeKey']] = [changeData['data']]
			} else {
				state[changeData['changeKey']] = changeData['data']
			}
		}
	},
	actions: {

		//根据组织机构获取项目列表
		//获取我的项目列表
		getMyProjectList({ commit, state }, deptId) {
			return new Promise(resolve => {
				getData(`logistics/project/my/list?deptId=${deptId}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: '操作成功',
							data: res.data
						})
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						})
					}
				})
			})
		},

		//获取订单
		getOrderList({ commit, state }, data) {
			return new Promise(resolve => {
				getData(`logistics/order/index/list`, {
					pid: data.projectId,
					year: data.year,
					month: data.month
				}).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: [],
							msg: res.msg
						})
					}
				})
			})
		},

		//获取订单详情
		getIinfoById({ commit, state }, id) {
			return new Promise(resolve => {
				getData(`logistics/order/get/${id}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},


		//根据订单、调度、项目获取运单
		getWaybillList({ commit, state }, data) {
			return new Promise(resolve => {
				getData(`logistics/waybill/page?projectId=${data.projectId}&orderId=${data.orderId}&dispatchId=${data.dispatchId}&size=999999&page=1`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data.rows,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: [],
							msg: res.msg
						})
					}
				})
			})
		},

		//获取订单统计数据
		getOrderNumber({ commit, state }, id) {
			return new Promise(resolve => {
				getData(`logistics/order/tran/statistics/${id}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},


		//获取首页统计数据
		getStatisticsData({ commit, state }, data) {
			return new Promise(resolve => {
				const queryParams = config.jsonToQueryParams({
					year: data.year,
				month: data.month,
				deptId:data.deptId
				});
				getData(`logistics/index/vo?${queryParams}`).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data:res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data:null,
							msg: res.msg
						});
					}
				})
			})
		},
		//获取首页图表数据
		getEchartsData({ commit, state }, data) {
			const query = {
				year: data.year,
				month: data.month,
				deptId:data.deptId
			}
			return new Promise(resolve => {
				getData(`logistics/index/month/data`, query).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},


		//获取系统订单数
		getSysOrderNumber({ commit, state }, data) {
			const query = {
				year: data.year,
				month: data.month
			}
			return new Promise(resolve => {
				getData(`logistics/order/statistics/${data.pid}`, query).then(res => {
					if (res.state == 1) {
						resolve({
							state: 1,
							data: res.data,
							msg: '操作成功'
						})
					} else {
						resolve({
							state: 0,
							data: null,
							msg: res.msg
						})
					}
				})
			})
		},

		getAllowOrg({ commit, state }, year) {
			return new Promise((resolve) => {
				getData(`logistics/sys/dept/get/list`).then((res) => {
					if (res.state == 1) {
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data
						});
					} else {
						resolve({
							state: 0,
							msg: res.msg,
							data: []
						});
					}
				})
			})
		},


		//根据项目获取地图站点列表
		getMapSiteList({ commit, state }, projectId) {
			return new Promise(resolve => {
				getData(`logistics/station/list/${projectId}`).then((res)=>{
					if (res.state == 1){
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data	
						})
					}else{
						resolve({
							state: 0,
							data:[]
						})
					}
				});
			})
		},

		//查询运单详情
		getWaybillInfo({ commit, state }, id) {
		    return new Promise(resolve => {
				getData(`logistics/waybill/trajectory/list/${id}`).then((res)=>{
					if (res.state == 1){
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data	
						})
					}else{
						resolve({
							state: 0,
							data:[]
						})
					}
				});
			})
		},


		//获取运单详情
		getWayBillInfo({ commit, state }, id) {
		    return new Promise(resolve => {
				getData(`logistics/waybill/details/${id}`).then((res)=>{
					if (res.state == 1){
						resolve({
							state: 1,
							msg: "操作成功",
							data: res.data	
						})
					}else{
						resolve({
							state: 0,
							data:[]
						})
					}
				});
			})
		},

		//修改添加loading
		changeListLoading({ commit }, value) {
			commit('CHANGE_TABLE_LOADING', value)
		},
		//写入查询条件
		setSearchData({ commit }, changeData) {
			commit('CHANGE_SEARCH_COLL', changeData)
		}
	}
}
